import { decryptAES } from "./decryptAES ";
import { encryptAES } from "./encryptionAES";

export const encryptSSNFields = async (obj: any, password: string): Promise<any> => {
	if (typeof obj === "object" && obj !== null) {
		if (Array.isArray(obj)) {
			for (let i = 0; i < obj.length; i++) {
				obj[i] = await encryptSSNFields(obj[i], password);
			}
		} else {
			for (const key in obj) {
				if (key == "excel_data") {
					obj[key] = await encryptAES(JSON.stringify(obj[key]), password);
				} else if (Object.prototype.hasOwnProperty.call(obj, key)) {
					const lowerKey = key.toLowerCase();
					if (lowerKey.includes("ssn")) {
						const value = obj[key];
						if (typeof value === "string" || typeof value === "number") {
							obj[key] = await encryptAES(String(value), password);
						}
					}
					obj[key] = await encryptSSNFields(obj[key], password);
				}
			}
		}
	}
	return obj;
};

export const decryptSSNFields = async (obj: any, password: string): Promise<any> => {
	if (typeof obj === "object" && obj !== null) {
		if (Array.isArray(obj)) {
			for (let i = 0; i < obj.length; i++) {
				obj[i] = await decryptSSNFields(obj[i], password);
			}
		} else {
			for (const key in obj) {
				if (Object.prototype.hasOwnProperty.call(obj, key)) {
					const lowerKey = key.toLowerCase();

					if (lowerKey.includes("ssn") && typeof obj[key] === "string") {
						try {
							obj[key] = await decryptAES(obj[key], password);
						} catch (e) {
							console.warn(`❌ Failed to decrypt key "${key}":`, e);
						}
					} else if (typeof obj[key] === "object") {
						obj[key] = await decryptSSNFields(obj[key], password);
					}
				}
			}
		}
	}
	return obj;
};
